import React from "react";

/**
 * Minimal "T" monogram for Taonga OÜ.
 * Rendered as inline SVG so it scales crisply and stays brand-controlled.
 */
export const Monogram = ({ className = "h-9 w-9", title = "Taonga OÜ monogram" }) => {
  return (
    <svg
      viewBox="0 0 40 40"
      role="img"
      aria-label={title}
      className={className}
      data-testid="brand-monogram"
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="4" fill="#1A2B4C" />
      {/* Stylised T with subtle warm accent baseline */}
      <path d="M10 13 H30" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="square" />
      <path d="M20 13 V29" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="square" />
      <path d="M14 29 H26" stroke="#C5A880" strokeWidth="1.6" strokeLinecap="square" />
    </svg>
  );
};

export default Monogram;
